import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import routes from "../../../app/routes";

export default function Info({ collection, cycle, memberId, setCycle }) {
  const [info, setInfo] = useState(undefined);
  const [loaded, setLoaded] = useState(false);
  const [cycles, setCycles] = useState([]);

  const updateCycleInfo = () => {
    setLoaded(true);
    if (cycle != undefined) {
      axios
        .get(routes.api.students.enrollment(memberId), {
          params: { cycle_id: cycle.id },
        })
        .then((resp) => {
          setInfo(resp.data.data);
          setLoaded(false);
        });
    }
  };

  useEffect(() => {
    updateCycleInfo();
  }, [cycle]);

  useEffect(() => {
    const data = [...collection].map((item) => ({
      value: item.id,
      label: item.attributes.name,
    }));
    setCycles(data);
  }, [collection]);

  return (
    <>
      <h2>Benefit Plan Contribution</h2>
      <div>
        <b>Select Enrollment</b>
        <div className="row mt20">
          <div className="col-md-3 col-sm-6">
            <Select
              options={cycles}
              onChange={(value) => setCycle(value)}
              value={cycles.find((el) => el.value == cycle.id)}
            />
          </div>
        </div>
      </div>
      <div className="row mt20">
        {loaded && <p className="text-center mt20">Processing...</p>}

        {!loaded && info != undefined && (
          <>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Start and End Date</b>
              <div>
                {info.attributes.form_format_cycle_start} -{" "}
                {info.attributes.form_format_cycle_end}
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Effective Date</b>
              <div>{info.attributes.format_effective_date}</div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Program Selected</b>
              <div>{info.attributes.current_product}-session program</div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Program Cost</b>
              <div>{info.attributes.format_employee_total_cost}</div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Payroll Periods</b>
              <div>{info.attributes.pay_frequency}</div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b>Payroll Deduction</b>
              <div>{info.attributes.format_employee_pay_period}</div>
            </div>
            <div className="col-md-3 col-sm-6 mb10">
              <b className="green">Paid</b>
              <div>{info.attributes.total_paid}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
